import classnames from 'classnames';
import React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { HEADER_BRANDS_LINE_SIZE } from 'swag-client-common/constants';
import { LogoCategories } from '../logo-categories';
import anim from './anim.scss';
import { TextCategories } from './components/text-categories';
import classes from './subcategories-links.scss';
function getLinesCount(subcat = []) {
  const logosToShow = subcat.slice(0, 27);
  const count = Math.ceil(logosToShow.length / HEADER_BRANDS_LINE_SIZE) || 1;
  return count;
}
export const SubcategoriesLinksComponent = ({
  subcategories,
  currentRoute,
  currentMainCategory,
  currentSubcategoryId,
  parentCategory,
  isViolet = false,
  wrapperClassName = '',
  onLinkClick,
  isFilterOpened,
  isLogoCategory,
  isOneline,
  handleMouseEnter,
  shouldShow,
  allSubcategories,
  isFirstFocused,
  onKeyDown
}) => {
  const linesCount = !isLogoCategory || isOneline ? 1 : getLinesCount(subcategories);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.subMenu, wrapperClassName, {
      [classes.isFilterOpened]: isFilterOpened,
      [classes.hidden]: !shouldShow,
      [classes[`logoMenu${linesCount}`]]: isLogoCategory
    }),
    "data-id": parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory._id,
    onMouseEnter: handleMouseEnter
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    timeout: 150,
    in: shouldShow,
    key: (parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.name) || '',
    classNames: anim,
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.contentWrapper
  }, isLogoCategory ? /*#__PURE__*/React.createElement(LogoCategories, {
    subcategories: subcategories,
    currentRoute: currentRoute,
    currentMainCategory: currentMainCategory,
    currentSubcategoryId: currentSubcategoryId,
    parentCategory: parentCategory,
    onLinkClick: onLinkClick,
    isOneline: isOneline,
    isFirstFocused: isFirstFocused,
    onKeyDown: onKeyDown
  }) : /*#__PURE__*/React.createElement(TextCategories, {
    currentSubcategoryId: currentSubcategoryId,
    currentRoute: currentRoute,
    parentCategory: parentCategory,
    isViolet: isViolet,
    onLinkClick: onLinkClick,
    subcategories: subcategories,
    shouldShow: shouldShow,
    isFirstFocused: isFirstFocused,
    onKeyDown: onKeyDown
  })))), /*#__PURE__*/React.createElement(TextCategories, {
    currentSubcategoryId: currentSubcategoryId,
    currentRoute: currentRoute,
    parentCategory: parentCategory,
    isViolet: isViolet,
    onLinkClick: onLinkClick,
    subcategories: allSubcategories,
    shouldShow: false,
    allSubcategories: allSubcategories,
    isFirstFocused: isFirstFocused,
    onKeyDown: onKeyDown
  }));
};